import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { selectUser } from 'selectors';
import styled from 'styled-components';
import { Button, Container, Image, Text } from 'styled-minimal';

import { useAppSelector } from 'modules/hooks';

import { login, setEmail, setName } from 'actions';

import Background from 'components/Background';

const StyledContainer = styled(Container)`
  padding: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: rgb(55, 65, 81);
  // background-size: cover;
  // background-position: center;
  // background-image: url('${process.env.PUBLIC_URL}/media/images/background.png');
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 30px;
  flex-direction: column;
  font-size: 1.6rem;
  color: white;
`;

const StyledButton = styled(Button)`
  width: 142px;
  height: 40px;
  font-size: 1.6rem;
  border-radius: 4px;
  border: 2px solid white;
  text-transform: initial;
  display: flex;
  justify-content: center;
  color: black;
  background-color: white;
  box-shadow: 5px 5px 5px darken(rgba(red(#81c784), green(#81c784), blue(#81c784), 0.2), 2%),
    -5px -5px 5px lighten(rgba(red(#81c784), green(#81c784), blue(#81c784), 0.2), 2%);
  transition: ease all 0.3s;
  cursor: pointer;

  &:hover {
    box-shadow: 10px 10px 10px darken(rgba(red(#81c784), green(#81c784), blue(#81c784), 0.1), 2%),
      -10px -10px 10px lighten(rgba(red(#81c784), green(#81c784), blue(#81c784), 0.1), 2%);
    transform: translateY(-3px);
  }
  &:active {
    transform: scale(0.9);
    box-shadow: inset -1px -1px 3px
        darken(rgba(red(#81c784), green(#81c784), blue(#81c784), 0.3), 2%),
      -10px -10px 10px lighten(rgba(red(#81c784), green(#81c784), blue(#81c784), 0), 2%);
  }
`;

const LeftSide = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const RightSide = styled.div`
  position: absolute;
  right: 20px;
  top: 0;
  bottom: 20px;
  display: flex;
  flex-direction: column;
`;

const Heading = styled(Text)`
  color: rgb(55, 65, 81);
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  font-size: 120px;
  font-weight: 100;
  line-height: 30px;
  text-transform: uppercase;
`;

const Title = styled(Text)`
  font-size: 32px;
  color: white;
  text-transform: uppercase;
  line-height: 0px;
  margin-bottom: 50px;
`;

const Label = styled(Text)`
  color: white;
  font-weight: 100;
  line-height: 0px;
`;

const NameInput = styled.input`
  padding: 12px;
  font-size: 1.4rem;
  margin-bottom: 12px;
  outline: none;
  border-radius: 8px;
  border: none;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

function Home() {
  const dispatch = useDispatch();
  const user = useAppSelector(selectUser);
  const { name, email } = user;
  const nameInput = useRef<HTMLInputElement>(null);
  const emailInput = useRef<HTMLInputElement>(null);

  const handleClickLogin = (coach: number) => {
    // dispatch(login(coach, messages[coach].length > 0));
    if (!name) return nameInput.current?.focus();
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email))
      return emailInput.current?.focus();
    dispatch(login(coach, false));
  };

  return (
    <Background key="Home" data-testid="Home">
      <StyledContainer fullScreen>
        <LeftSide>
          <Image
            alt="star"
            src={`${process.env.PUBLIC_URL}/media/images/star.png`}
            style={{ position: 'absolute', top: '60px' }}
            width={80}
          />
          <Image
            alt="triangles"
            src={`${process.env.PUBLIC_URL}/media/images/triangles.png`}
            width={30}
          />
          <Image
            alt="circles"
            src={`${process.env.PUBLIC_URL}/media/images/circles.png`}
            style={{ position: 'absolute', bottom: '-60px', left: '-60px' }}
            width={200}
          />
        </LeftSide>
        <ButtonContainer>
          <Heading>Ikigai</Heading>
          <hr style={{ width: '100%' }} />
          <Title>A reason for being</Title>
          <Label>What's your name?</Label>
          <NameInput
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              dispatch(setName(event.target.value))
            }
            type="text"
            value={name}
            placeholder="Type your name here"
            ref={nameInput}
          />
          <Label>What's your email address?</Label>
          <NameInput
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              dispatch(setEmail(event.target.value))
            }
            type="text"
            value={email}
            placeholder="Type your email address here"
            ref={emailInput}
          />
          <Buttons>
            <StyledButton
              data-testid="MentorMirror"
              onClick={() => handleClickLogin(0)}
              // size="xl"
              textTransform="uppercase"
              variant="primary"
            >
              <Text>Begin Chat</Text>
            </StyledButton>
          </Buttons>
        </ButtonContainer>
        <Image alt="venn" src={`${process.env.PUBLIC_URL}/media/images/venn.svg`} width={500} />
        <RightSide>
          <div style={{ flex: 1 }} />
          <Image
            alt="purple_dots"
            src={`${process.env.PUBLIC_URL}/media/images/purple_dots.png`}
            style={{ alignSelf: 'end', marginRight: '8px' }}
            width={16}
          />
          <div style={{ flex: 1 }} />
          <Image
            alt="white_dots"
            src={`${process.env.PUBLIC_URL}/media/images/white_dots.png`}
            width={400}
          />
        </RightSide>
      </StyledContainer>
    </Background>
  );
}

export default Home;
